
export default {
  name: 'SectionIconsDescriptions',
  props: {
    data: {
      required: true,
      type: Object,
      default: function () {
        return {
          centerContent: false
        }
      }
    },
    orderNo: {
      required: true,
      type: Number,
      default: 0
    },
    hash: {
      required: true,
      type: String,
      default: ''
    }
  }
}
